import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance } from 'vue';
import { SeriesResponse } from '@/types/cms';
import { Language } from '@/enums/language';
import { useStore } from '@/composables/useStore';
import { RouteName, routeTo } from '@/router/routes';
import TG4Image from '@/components/TG4Image.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CarouselCell',
  props: {
    series: null,
    dimmed: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  series: SeriesResponse;

  dimmed?: boolean;
};





const { useGetter } = useStore();
const currentLanguage = useGetter<string>('currentLanguage');

const instance = getCurrentInstance();
const router = instance?.proxy?.$router;

const image = computed(() => props.series.heroImage ?? props.series.mainImage);

const tagline = computed(() => {
  const { taglineEn, taglineGa, descEn, descGa } = props.series;
  return currentLanguage.value === Language.Irish
    ? taglineGa ?? descGa
    : taglineEn ?? descEn;
});

const navigateToSeries = () => {
  router?.push(routeTo(RouteName.Series, { slugOrVID: props.series.slug }));
};

return { __sfc: true,props, useGetter, currentLanguage, instance, router, image, tagline, navigateToSeries, TG4Image }
}

})